import { MonthlyReport } from '../../../store/useStore'
import { isPANASReportComplete } from '../../../utils/reportCompletion'
import { getDietStatus } from '../../../utils/dietStatus'

export type DashboardStatus = 'unstarted' | 'inProgress' | 'complete'

export const getALSFRSStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  if (!report || !report.alsfrs) return 'unstarted'
  return report.alsfrs.score === undefined ? 'inProgress' : 'complete'
}

export const getALSSQStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  if (!report || !report.alssq) return 'unstarted'
  return report.alssq.score === undefined ? 'inProgress' : 'complete'
}

export const getMindsetStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  if (!report || !report.panas) return 'unstarted'
  return isPANASReportComplete(report.panas) ? 'complete' : 'inProgress'
}

export const getStoolUrineStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  if (!report || !report.stool) return 'unstarted'
  return report.stool.stool.complete && report.stool.urine.complete
    ? 'complete'
    : 'inProgress'
}

export const getVitalStatsStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  if (!report?.vitalStats) return 'unstarted'
  return !report.vitalStats.weight ? 'inProgress' : 'complete'
}

export const getClinicalObservationsStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return !report?.clinicalObservations ? 'unstarted' : 'complete'
}

export const getDietStatusFromReport = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return getDietStatus(report) as DashboardStatus
}

export const getSupplementsStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return !report?.supplements ? 'unstarted' : 'complete'
}

export const getMedicationsStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return !report?.nonSupplementMedications ? 'unstarted' : 'complete'
}

export const getPhysicalStrategiesStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return !report?.physicalStrategies ? 'unstarted' : 'complete'
}

export const getMentalStrategiesStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return !report?.mentalStrategies ? 'unstarted' : 'complete'
}

export const getStagesStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return !report?.stages ? 'unstarted' : 'complete'
}

export const getSupportStatus = (
  report: MonthlyReport | undefined
): DashboardStatus => {
  return !report?.support ? 'unstarted' : 'complete'
}

// Status calculator functions mapped by step
export const statusCalculators = {
  1: getALSFRSStatus,
  2: getALSSQStatus,
  3: getMindsetStatus,
  4: getStoolUrineStatus,
  5: getVitalStatsStatus,
  6: getClinicalObservationsStatus,
  7: getDietStatusFromReport,
  8: getSupplementsStatus,
  9: getMedicationsStatus,
  10: getPhysicalStrategiesStatus,
  11: getMentalStrategiesStatus,
  12: getStagesStatus,
  13: getSupportStatus,
}
